module.exports = {
  // 页面尺寸
  pageInfo: {
    bodyWidth: 375,
    bodyHeight: 667
  },
  userInfo: {
  }
}



// WEBPACK FOOTER //
// ./src/store/global/state.js